import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const mapToCSSModule = (classes, theme) => {
  return classNames(Array.isArray(classes) ? classes.map(c => theme[c]) : theme[classes])
}

const DatagridCell = ({ classes, field, index, record, resource, theme, ...rest }) => {
  return (
    <td className={mapToCSSModule(classes, theme)} {...rest}>
      {React.cloneElement(field, { record, resource, index })}
    </td>
  )
}

DatagridCell.propTypes = {
  classes: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  field: PropTypes.element,
  record: PropTypes.object,
  resource: PropTypes.string,
  theme: PropTypes.object,
}

export default DatagridCell



// WEBPACK FOOTER //
// ./ui/DataTable/DatagridCell.js